module.exports = __webpack_public_path__ + "static/fipctransport2-3b6042b5f69ed8b1c41608518845d40f.jpeg";